import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import config from "../../config.json";
import {getMessage} from "../../util";

const useStyles = makeStyles(theme => ({
        paper: {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
        },
        voted: {
            marginTop: theme.spacing(4),
        },
        paragraph: {
            margin: theme.spacing(2)
        },
        cardGrid: {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),
        },
        card: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        cardActions: {
            justifyContent: 'center',
        },
        cardContent: {
            flexGrow: 1,
        },
        option: {
            margin: theme.spacing(3),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',

        },
        label: {
            alignItems: 'left',
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: '25ch',
        },
        number: {
            fontFamily: "monospace"
        }

    }
));

const VotedDistributed = (props) => {
    const classes = useStyles();

    const shares = props.answers.reduce((acc, a) => {
        Object.keys(a.votes).forEach(k => {
            acc[k] = (acc[k]?acc[k]:0)+a.votes[k].shares;
        });
        return (acc);
    }, {});


return (
    <Container maxWidth={"xs"} className={classes.voted}>
        <Typography variant={"h6"}>
            {getMessage(props.meeting.meeting_type, 'voted_message', props.messages)}
        </Typography>

        {props.answers && props.answers.sort((a, b) => {
            return (a.order - b.order);
        }).map(a => (
            <Typography className={classes.paragraph} key={"o" + a._id}>
                {a.name}: <br/>
                {Object.keys(a.votes).map(k => (
                    <Fragment key={k} >
                        {a.votes[k].name}: <span className={classes.number}>{a.votes[k].shares.toLocaleString(navigator.language, {
                        maximumFractionDigits: config.precision
                    })}</span>
                        <br/>
                    </Fragment>
                ))}
            </Typography>

        ))}

            <Typography className={classes.paragraph}>
                {getMessage(props.meeting.meeting_type, 'blanks', props.messages)}: <br/>
                {Object.keys(shares).map(k => (
                    <Fragment key={k}>
                        {props.user.shares[k].name}: <span className={classes.number}>{(props.user.shares[k].shares - shares[k]).toLocaleString(navigator.language, {
                        maximumFractionDigits: config.precision
                    })}</span>
                        <br/>
                    </Fragment>
                ))}
            </Typography>



    </Container>
)
}

export default VotedDistributed;